import { useRecoilState } from "recoil";
import { authAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { listEmailTemplateAtom } from "state/show";
import { totalRow } from "state/roles-permissions";

const useNotification = () => {
  const [auth] = useRecoilState(authAtom);
  const [emailTemplateList, setEmailTemplateList] = useRecoilState(listEmailTemplateAtom);
  const [totalRows, setTotalRows] = useRecoilState(totalRow);

  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  return {
    getEmailHistoryByBooking,
    getListEmailTemplate,
    getEmailTemplateDetail,
    createEmailTemplate,
    updateEmailTemplate,
    createTemplateDetail,
    getTemplateDetailById,
    updateTemplateDetail,
    sendTestEmail,
    getActiveTemplateDetail,
  };

  function getEmailHistoryByBooking(transactionRef, templateId) {
    const params = {
      offset: 0,
      limit: 200,
      transaction_ref: transactionRef,
      template_id: templateId,
    };

    return instance({
      url: "notification/v1/management/messages",
      method: "GET",
      params,
      headers
    });
  }

  function getListEmailTemplate(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }
    return instance({
      url: "notification/v1/management/templates",
      method: "GET",
      headers,
      params
    })
      .then((res) => {
        if (res.status === 200) {
          setEmailTemplateList(res.data.data || []);
          setTotalRows((preState) => ({
            ...preState,
            emailTemplates: res.data.meta.total,
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getEmailTemplateDetail(templateId) {
    return instance({
      url: `notification/v1/management/templates/${templateId}`,
      method: "GET",
      headers
    });
  }

  function createEmailTemplate(data) {
    return instance({
      url: "notification/v1/management/templates",
      method: "POST",
      data,
      headers
    });
  }

  function updateEmailTemplate(data, templateId) {
    return instance({
      url: `notification/v1/management/templates/${templateId}`,
      method: "PUT",
      headers,
      data
    });
  }

  function createTemplateDetail(data) {
    return instance({
      url: "notification/v1/management/template-details",
      method: "POST",
      data,
      headers
    });
  }

  function getTemplateDetailById(detailId) {
    return instance({
      url: `notification/v1/management/template-details/${detailId}`,
      method: "GET",
      headers
    });
  }

  function updateTemplateDetail(data, detailId) {
    return instance({
      url: `notification/v1/management/template-details/${detailId}`,
      method: "PUT",
      headers,
      data
    });
  }

  function sendTestEmail(data) {
    return instance({
      url: "notification/v1/management/template-details/send-test",
      method: "POST",
      data,
      headers
    });
  }

  function getActiveTemplateDetail(templateCode) {
    return instance({
      url: `notification/v1/management/template-details/active/${templateCode}`,
      method: "GET",
      headers
    });
  }
};

export { useNotification };
